const customerManagementComponentLoaders = Object.freeze({
  'customer-management.workspace': async () => {
    const module = await import('./customer-workspace-component.js');
    return module.CustomerWorkspaceComponent;
  },
});

export default customerManagementComponentLoaders;
